export const PUBLIC_TRIAL_SECONDS = 300;
export const PUBLIC_TRIAL_MS = PUBLIC_TRIAL_SECONDS * 1_000;
export type PublicTrialPolicy = { mode: "limited"; seconds: number } | { mode: "unlimited" };

/** Missing/invalid metadata retains the default; only explicit unlimited removes it. */
export function publicTrialSeconds(policy?: PublicTrialPolicy): number | null {
  if (policy?.mode === "unlimited") return null;
  return policy?.mode === "limited" && Number.isInteger(policy.seconds) && policy.seconds > 0 && policy.seconds <= 86_400
    ? policy.seconds : PUBLIC_TRIAL_SECONDS;
}
export function trialStartLabel(policy?: PublicTrialPolicy) {
  const seconds = publicTrialSeconds(policy);
  if (seconds === null) return "Try app";
  return seconds % 60 === 0 ? `Try for ${seconds / 60} ${seconds === 60 ? "minute" : "minutes"}` : `Try for ${seconds} seconds`;
}
